import "../../../components/Table/Table.css";

const AttendanceMarkedTimes = ({ data }) => {
  const items = data || [];

  if (!items.length) {
    return <div className="attendance-marked-empty">No attendance marking data available for this date.</div>;
  }

  return (
    <div className="app-data-table attendance-marked-scroll">
      <table className="table table-bordered table-hover table-striped mb-0">
        <thead>
          <tr>
            <th style={{ minWidth: "180px" }}>Class</th>
            <th style={{ minWidth: "180px" }}>Attendance Marked Time</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, idx) => (
            <tr key={idx}>
              <td>{item.class}</td>
              <td>{item.attendance_times}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AttendanceMarkedTimes;
